module.exports = __webpack_public_path__ + "img/drop-down-icon.887b9e1c474e898d7f5334920fd92a02.svg";